import api from '@/api/establishment'

const state = {
  all: []
}

// getters
const getters = {
}

// actions
const actions = {
  all ({ commit }) {
    return api.all().then(
      (r) => {
        if (r.data.err == null) {
          commit('setAll', r.data.v)
        }
        return r
      }
    )
  },

  update ({ dispatch }, request) {
    return api.update(request).then(
      (r) => {
        if (r.data.err == null) {
          dispatch('all')
        }
        return r
      }
    )
  }
}

// mutations
const mutations = {
  setAll (state, all) {
    state.all = Object.freeze(all)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
